import { Ayah, UserDataType, Word } from '@app-types/KuranTypes'
import Tooltip from '@components/shared/Tooltip/Tooltip'
import React, { useCallback, useState } from 'react'
import toast from 'react-hot-toast'
import { FaCopy, FaShare } from 'react-icons/fa'
import { FaBookmark } from 'react-icons/fa'
import AyahCollection from './AyahCollection'
import AyahTefsir from './AyahTefsir'
import { getBundledAyahTefsir } from 'helpers/quranPageTefsir'

function Separator({
  i,
  ayah,
  ayahNo,
  word,
  ayahs,
  hideTooltip,
  mealSource,
}: {
  i: number
  ayah: Ayah
  ayahNo: number
  word: Word
  ayahs: any
  hideTooltip: boolean
  mealSource: UserDataType['kuranMealSource']
}) {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false)
  const [showForm, setShowForm] = useState(false)

  const mealText = React.useMemo(() => {
    return ayah[mealSource]
  }, [ayah, mealSource])

  const getFullText = () => {
    return `${ayah.surah.name} - ${ayah.verse_number} \n\n ${ayah.verse}\n\n${mealText}`
  }

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: 'Hayırhah',
        text: getFullText(),
        url: window.location.href,
      })

      toast.success('Paylaşıldı')
    } else {
      handleCopy()
    }
  }

  const handleCopy = useCallback(() => {
    if (navigator?.clipboard?.writeText) {
      navigator?.clipboard?.writeText(getFullText())
      toast.success('Kopyalandı')
    } else {
      toast.error('Tarayıcınız kopyalama işlemini desteklemiyor.')
    }
  }, [ayah.verse_number, ayah.verse, mealText])

  const tooltipContent = (
    <div className="min-w-[300px]">
      {!showForm && <span className="block">{mealText}</span>}
      {/* Uses the tefsir bundled in the app; otherwise fetched when opened. */}
      {!showForm && (
        <AyahTefsir
          surahId={ayah.surah.id}
          verseNumber={ayah.verse_number}
          bundledTefsir={getBundledAyahTefsir(ayah, ayahs)}
        />
      )}
      <div className="relative flex justify-center space-x-4 mt-3">
        {!showForm && (
          <>
            <button
              className="flex items-center hover:bg-gray-400 dark:hover:bg-gray-700 px-2 py-1 rounded-md text-sm transition"
              onClick={handleShare}
              aria-label="Ayeti Paylaş"
              title="Ayeti Paylaş"
              type="button"
            >
              <FaShare width={18} />
              <span className="ml-1">Paylaş</span>
            </button>
            <button
              className="flex items-center hover:bg-gray-400 dark:hover:bg-gray-700 px-2 py-1 rounded-md text-sm transition"
              onClick={handleCopy}
              aria-label="Ayeti Kopyala"
              title="Ayeti Kopyala"
              type="button"
            >
              <FaCopy width={18} />
              <span className="ml-1">Kopyala</span>
            </button>
            <button
              className="flex items-center hover:bg-gray-400 dark:hover:bg-gray-700 px-2 py-1 rounded-md text-sm transition"
              onClick={() => setShowForm(true)}
              aria-label="Ayeti Kaydet"
              title="Ayeti Kaydet"
              type="button"
            >
              <FaBookmark width={18} />
              <span className="ml-1">Kaydet</span>
            </button>
          </>
        )}
      </div>
      <AyahCollection
        ayah={ayah}
        onFormVisibilityChange={setShowForm}
        showForm={showForm}
      />
    </div>
  )

  return (
    <React.Fragment key={i}>
      <Tooltip
        disabled={hideTooltip}
        trigger="click"
        interactive={true}
        className="ayah-meal text-left"
        onShow={() => setIsTooltipOpen(true)}
        onHide={() => {
          setIsTooltipOpen(false)
          setShowForm(false)
        }}
        content={tooltipContent}
      >
        <div
          className="flex justify-center items-center px-2 ayah-id ayah-separator text-2xl cursor-pointer"
          data-ayah-id={ayahNo}
          id={`ayah-${ayah.verse_number}`}
        >
          {word.separator}
        </div>
      </Tooltip>
      {ayahs.length === ayahNo + 1 && <div className="m-auto"> &nbsp; </div>}
    </React.Fragment>
  )
}

export default Separator
